import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MailModal from '../../mailModal';
import './FooterItem.less';



class FooterItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      currentTitle: ''
    }
  };
  changeModal = (value) => {
    this.setState({
        isShow: value,
    });
  }
  render() {
    const { itemData = {} } = this.props;
    const { isShow, currentTitle } = this.state;
    
    return (
      <div className="footer-item">
        <div className="footer-item-title">
          {itemData.title || ''}
        </div>
        {
          !!itemData.data && itemData.data.map((item, index) => {
            return <div key={'footer-item-list' + index} className="footer-item-list">
              <span>
                {!item.isModal&&<a
                  onClick={()=>{
                   
                  }}
                  href={item.href||"javascript:void(0);"} 
                  target={item.target||"_blank"} 
                  rel="noopener noreferrer">{item.title || ''}</a>}
                {!!item.isModal&&<a onClick={() => {
                  this.setState({
                    currentTitle: item.title || ''
                  })
                  this.changeModal(true)
                  }}>{item.title || ''}</a>}
              </span>
            </div>
          })
        }
        <div>
          <MailModal title={currentTitle} isShow={isShow} changeModal={()=>this.changeModal()} />
        </div>
      </div>
    );
  }
}
// 指定 props 的默认值：
FooterItem.defaultProps = {
  type: 'iso',
};

FooterItem.propTypes = {
  type: PropTypes.string,
};

export default FooterItem;
